<template>
  <leaflet-offline-map :config="$options.config" :markers="markers" ref="leafletOfflineMap" />
</template>

<script>
import proj4 from "@/wrappers/proj4";
import LeafletOfflineMap from "@/components/LeafletOfflineMap";

export default {
  config: {
    height: 360,
    offlineDownload: false,
    hasOfflineControl: false,
    hasLocateControl: false
  },
  props: {
    forms: {
      type: Array,
      default: () => []
    }
  },
  components: {
    LeafletOfflineMap
  },
  computed: {
    markers() {
      let markers = [];
      this.forms.forEach(form => {
        let lat = form.device_lat_start;
        let lng = form.device_lng_start;
        if ( ! lat || ! lng) {
          const coord_sources = [
            // In order of relevance/suitability!
            { lat: form.device_lat_finish, lng: form.device_lng_finish, type: 'GPS' },
            { lat: form.order.latitudeStart, lng: form.order.longitudeStart, type: 'NZTM' },
            { lat: form.order.latitudeFinish, lng: form.order.longitudeFinish, type: 'NZTM' },
            { lat: form.order.loggedYCoordinate, lng: form.order.loggedXCoordinate, type: 'NZTM' }
          ];
          coord_sources.forEach(set => {
            if (lat && lng) return;
            // Reminder: we do sometimes get coordinates like "      0.0000" from AKCL
            // so we will double check that our values appear to be usable as floats.
            let set_lat = _.isString(set.lat) ? parseFloat(_.trim(set.lat)) : set.lat;
            let set_lng = _.isString(set.lng) ? parseFloat(_.trim(set.lng)) : set.lng;
            if ( ! _.isFinite(set_lat)) set_lat = null;
            if ( ! _.isFinite(set_lng)) set_lng = null;
            if (set_lat && set_lng) {
              let latitude, longitude;
              if (set.type.toUpperCase() === 'NZTM') {
                try {
                  const orderCoords = proj4('NZTM', 'GPS', [set_lng, set_lat]);
                  [longitude, latitude] = orderCoords;
                  lng = longitude;
                  lat = latitude;
                }
                catch (err) {
                  window.console && console.log(err);
                  lat = null;
                  lng = null;
                }
              }
              else if (set.type.toUpperCase() === 'GPS') {
                // Shouldn't need to do anything. Already desired format
                lat = set_lat;
                lng = set_lng;
              }
            }
          });
        }
        // Hopefully have coords by now
        if (lat && lng) {
          markers.push({
            latLng: [lat, lng],
            popup: {
              content: `<a href="/forms/${form.id}">${form.id_alt}</a>`
            }
          });
        }
      });
      return markers;
    }
  },
  watch: {
    markers() {
      this.$refs.leafletOfflineMap.clearLayer("markers");
      this.$nextTick(() => {
        this.$refs.leafletOfflineMap.loadMarkers();
        this.$refs.leafletOfflineMap.fitMainLayerBounds();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Forms/list/partials/map.vue